import { Remediation } from 'src/app/models/remediation-profile/remediation';
import { LoggingService } from '../logging/logging.service';
import { ParticipantsListService } from '../participants-list/participants-list.service';
import { VirtualBackgroundService } from '../virtual-background/virtual-background.service';

export class RemediationProfileApplier {

  constructor(
    private logging: LoggingService,
    private participants: ParticipantsListService,
    private background: VirtualBackgroundService,
  ) {}

  applyRemediations(
    id: string,
    sharing: boolean,
    participantRemediations: Remediation,
    shareRemediations: Remediation,
    shareVideoTrack: MediaStreamTrack,
    shareAudioTrack: MediaStreamTrack,
  ): void {
    let remediation: Remediation;
    const tracks: MediaStreamTrack[] = [];
    if (!this.participants.participants[id]) {
      return;
    }
    if (sharing) {
      remediation = shareRemediations;
      if (shareVideoTrack) {
        tracks.push(shareVideoTrack);
      }
      if (shareAudioTrack) {
        tracks.push(shareAudioTrack);
      }
    } else {
      remediation = participantRemediations;
      this.participants.participants[id].tracks.forEach((sender) => {
        tracks.push(sender.track);
      });
    }

    const pc = this.participants.participants[id]?.pc;
    if (pc) {
      let widthScale;
      let heightScale;
      if (this.background.isActive) {
        const canvas = document.getElementById('home-video-canvas') as HTMLCanvasElement;
        if (!canvas) {
          return;
        }
        widthScale = canvas.width / remediation.local[id].video.width;
        heightScale = canvas.height / remediation.local[id].video.height;
      } else {
        widthScale = remediation.max.width / remediation.local[id].video.width;
        heightScale = remediation.max.height / remediation.local[id].video.height;
      }
      const scale = widthScale > heightScale ? widthScale : heightScale;
      pc.getSenders().forEach((pSender) => {
        if (pSender.track && pSender.track.kind === 'video') {
          if (tracks.find((track) => track.id === pSender.track.id)) {
            const parameters = pSender.getParameters();
            if (parameters && parameters.encodings) {
              for (const encoding of parameters.encodings) {
                encoding.maxBitrate = remediation.local[id].bitrate * 1000;
                encoding.maxFrameRate = remediation.local[id].video.framerate;
                if (scale > 1) {
                  encoding.scaleResolutionDownBy = scale;
                } else {
                  encoding.scaleResolutionDownBy = 1;
                }
              }
            }
            pSender.setParameters(parameters).catch((err) => {
              this.logging.warning('IssueRemediationService: RTCRtpSender error - Setting video parameters on the sender', {
                id,
                pSender
              }, remediation.local[id].id);
            });
          }
        }
        if (pSender.track && pSender.track.kind === 'audio') {
          if (tracks.find((track) => track.id === pSender.track.id)) {
            const parameters = pSender.getParameters();
            if (parameters && parameters.encodings) {
              for (const encoding of parameters.encodings) {
                encoding.maxBitrate = remediation.local[id].audio.bitrate * 1024;
              }
            }
            pSender.setParameters(parameters).catch((err) => {
              this.logging.warning('IssueRemediationService: RTCRtpSender error - Setting audio parameters on the sender', {
                id,
                pSender
              }, remediation.local[id].id);
            });
          }
        }
      });
    }
  }
}
